import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BarraLateralClinica = () => {
    const location = useLocation();
    
    // Auth check
    const user = JSON.parse(localStorage.getItem('user'));
    const roleName = user?.role_details?.name;
    const isAdmin = roleName === 'SUPER_ADMIN' || roleName === 'ADMIN_FAST_FOOD' || roleName === 'ADMIN_CLINIC' || user?.is_superuser;

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                Clínica Dental
            </div>
            <ul className="sidebar-nav">
                <li className={isActive('/clinica')}>
                    <Link to="/clinica">Panel Principal</Link>
                </li>
                <li className={isActive('/clinica/agenda')}>
                    <Link to="/clinica/agenda">Agenda / Citas</Link>
                </li>
                <li className={isActive('/clinica/consultas')}>
                    <Link to="/clinica/consultas">Consultas</Link>
                </li>
                <li className={isActive('/clinica/pacientes')}>
                    <Link to="/clinica/pacientes">Pacientes</Link>
                </li>
                <li className={isActive('/clinica/servicios')}>
                    <Link to="/clinica/servicios">Servicios</Link>
                </li>
                <li className={isActive('/clinica/procedimientos')}>
                    <Link to="/clinica/procedimientos">Procedimientos</Link>
                </li>
                <li className={isActive('/clinica/graficos-consentimiento')}>
                    <Link to="/clinica/graficos-consentimiento">Gráficos Consentimiento</Link>
                </li>

            </ul>
        </aside>
    );
};

export default BarraLateralClinica;